import styled from 'styled-components';

export default styled.div`
  grid-row: 1;
  ${({ isSidebarOpen, sidebarPosition, overlapSidebar }) =>
    isSidebarOpen
      ? `
      grid-column: ${sidebarPosition === 'right' || overlapSidebar ? '1' : '2'} / span ${
          sidebarPosition === 'right' && !overlapSidebar ? '2' : '3'
        };
    `
      : `
      grid-column: 1 / span 3;
    `};
`;
